import React from 'react';

const CustomError = ({ error }) => (error && (error.shortMessage || error.longMessage) ? (
	<>
		<h1>
				⚠️
			{error.shortMessage}
		</h1>
		<br />
		<p>{error.longMessage}</p>
		<p>{error.suggestAction}</p>
	</>
) : null);

export default CustomError;
